import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogButton } from '../../../models/enums/dialogbutton.enum';
import { BaseDialog } from '../../dialogs/basedialog/base.dialog';

@Component({
    selector: 'documentation-dialog',
    templateUrl: './documentation.dialog.html'
})
export class DocumentationDialog {

    TextInnerHtml;

    static ShowDialog(text) {
        BaseDialog.ShowDialog({
            ContentType: DocumentationDialog,
            InitArgs: {
                Text: text
            },
            Buttons: DialogButton.Ok,
            Title: '@@Documentation'
        });
    }

    constructor(private sanitizer: DomSanitizer) {
    }

    Initialize(args) {
        if (args && args.Text) {
            this.TextInnerHtml = this.sanitizer.bypassSecurityTrustHtml(args.Text);
        } else {
            this.TextInnerHtml = '';
        }
    }
}
